import { get,postP } from '@/utils/axios'

export default {
    
    // 登录
    signIn(datas){
        return postP('Login/RequestToken/requestToken',datas)
    }
}